import { render, staticRenderFns } from "./card.vue?vue&type=template&id=070f11b1&"
import script from "./card.vue?vue&type=script&lang=ts&"
export * from "./card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports